import { ArrowRight } from 'lucide-react';

export const GoldButton = ({ children, href, onClick, testId, ghost = false, className = '' }) => {
  const base =
    'group relative inline-flex items-center justify-center gap-2.5 overflow-hidden rounded-full px-8 py-4 text-[13px] font-bold tracking-[0.18em] uppercase transition-transform duration-300 hover:scale-[1.03] active:scale-[0.98]';
  const skin = ghost
    ? 'border border-white/15 text-neutral-300 hover:border-gold/50 hover:text-gold-light transition-colors'
    : 'bg-gold text-black shadow-[0_0_40px_rgba(212,175,55,0.25)] hover:shadow-[0_0_60px_rgba(212,175,55,0.4)] transition-shadow';

  const inner = (
    <>
      {!ghost && (
        <span className="pointer-events-none absolute inset-0 -translate-x-full bg-gradient-to-r from-transparent via-white/40 to-transparent transition-transform duration-700 group-hover:translate-x-full" />
      )}
      <span className="relative z-10">{children}</span>
      <ArrowRight className="relative z-10 h-4 w-4 transition-transform duration-300 group-hover:translate-x-1" strokeWidth={2.5} />
    </>
  );

  if (href) {
    return (
      <a data-testid={testId} href={href} target="_blank" rel="noopener noreferrer" onClick={onClick} className={`${base} ${skin} ${className}`}>
        {inner}
      </a>
    );
  }
  return (
    <button data-testid={testId} onClick={onClick} className={`${base} ${skin} ${className}`}>
      {inner}
    </button>
  );
};
